export const DELIVERY_DATE_FORMAT = 'YYYY-MM-DD'

export const DELIVERY_JOB_STATUS = {
  UNSCHEDULED: 'unscheduled',
  SCHEDULED: 'scheduled',
  PROCESSING: 'processing',
  READY: 'ready',
  PUBLISHED: 'published'
}
